export const GET_MASTERDATA_DETAILS = 'GET_MASTERDATA_DETAILS';
